// Acciones
export const FETCH_CONFIG_VIDRIERA = 'configGlobalReducer/FETCH_CONFIG_VIDRIERA';
export const FETCH_CONFIG_VIDRIERA_SUCCESS = 'configGlobalReducer/FETCH_CONFIG_VIDRIERA_SUCCESS';
export const FETCH_CONFIG_VIDRIERA_FAILURE = 'configGlobalReducer/FETCH_CONFIG_VIDRIERA_FAILURE';

// Creadores de acciones
export const fetchConfigVidriera = () => ({
  type: FETCH_CONFIG_VIDRIERA,
});

export const fetchConfigVidrieraSuccess = (payload) => ({
  type: FETCH_CONFIG_VIDRIERA_SUCCESS,
  payload,
});

export const fetchConfigVidrieraFailure = (payload) => ({
  type: FETCH_CONFIG_VIDRIERA_FAILURE,
  payload,
});